import React from 'react';
import Particles from 'react-particles-js';
import particlesConfig from '../data/particlesjsConfig';

const Hero = () => (
  <>
    <div
      className="hero hero-bg lg:h-768p mx-auto relative"
      style={{ height: '100vh' }}
    >
    <Particles params={particlesConfig} className="App-particles__container" />
      <div className="hero-main py-5 px-3 lg:p-12 text-left md:text-center z-0">
        <h1 className="text-5xl lg:text-7xl font-bold text-primary">
          Hi, I'm <br className="md:hidden" />
          Nishantha
        </h1>
        <h3 className="text-xl lg:text-3xl my-3 text-primary">
          Full-stack Engineer
        </h3>
        <div className="hero-contact flex justify-between mt-6 lg:mt-9 xl:mt-10 text-secondary">
          <IconBtn
            iconHref="//linkedin.com/in/nishantha-kumara-nk"
            iconClass="fab fa-linkedin"
          />
          <IconBtn
            iconHref="//github.com/nishantha-kumara"
            iconClass="fab fa-github"
          />
          <IconBtn
            iconHref="//twitter.com/__nishantha"
            iconClass="fab fa-twitter"
          />
          <IconBtn
            iconHref="//instagram.com/nishantha__k/"
            iconClass="fab fa-instagram"
          />
          <IconBtn
            iconHref="//facebook.com/sweetnk"
            iconClass="fab fa-facebook"
          />
        </div>
      </div>
    </div>
    
  </>
);

const IconBtn = ({ iconHref, iconClass }) => {
  return (
    <a href={iconHref} target="_blank" rel="noreferrer">
      <i
        className={`${iconClass} hover:text-primary text-2xl lg:text-2xl xl:text-3xl`}
      ></i>
    </a>
  );
};

export default Hero;
